import { render, staticRenderFns } from "./LobbyParticipants.vue?vue&type=template&id=486fa30b&scoped=true&"
import script from "./LobbyParticipants.vue?vue&type=script&lang=js&"
export * from "./LobbyParticipants.vue?vue&type=script&lang=js&"
import style0 from "./LobbyParticipants.vue?vue&type=style&index=0&id=486fa30b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486fa30b",
  null
  
)

export default component.exports